export enum PREVENT_CHARACTER {
  NUMBER,
  LETTER,
  SPECIAL_CHAR,
  SPECIAL_CHAR_EXCEPT_PLUS,
}

export class PreventCharacterHelper {
  public static preventMultiple(event: KeyboardEvent, characters: PREVENT_CHARACTER[]): string {
    let value = (event.target as HTMLInputElement).value;
    characters.forEach((c) => {
      switch (c) {
        case PREVENT_CHARACTER.NUMBER:
          value = this.noNumber(value);
          break;
        case PREVENT_CHARACTER.LETTER:
          value = this.noLetter(value);
          break;
        case PREVENT_CHARACTER.SPECIAL_CHAR:
          value = this.noSpecialChar(value);
          break;
        case PREVENT_CHARACTER.SPECIAL_CHAR_EXCEPT_PLUS:
          value = this.noSpecialCharExceptPlus(value);
          break;
      }
    });
    return value;
  }

  public static noNumber(value: string): string {
    return value.replace(/[0-9]/g, "");
  }

  public static noLetter(value: string): string {
    return value.replace(/[A-Za-z- ']/g, "");
  }

  public static noSpecialChar(value: string): string {
    return value.replace(/[^a-zA-Z0-9]/g, "");
  }

  public static noSpecialCharExceptPlus(value: string): string {
    return value.replace(/[^a-zA-Z0-9+]/g, "");
  }
}
